import { useState, useEffect } from 'react';

export interface BeeHealthStatus {
  status: 'healthy' | 'degraded' | 'critical';
  lastCheck: string;
  details?: any;
}

interface BeeHealthData {
  summary: {
    total: number;
    healthy: number;
    unhealthy: number;
    avgResponseTime: number;
  };
  bees: Array<{
    name: string;
    status: 'healthy' | 'error';
    responseTime: number;
    lastChecked: string;
    error?: string;
    details?: any;
  }>;
  timestamp: string;
}

export const useBeeHealth = () => {
  const [beeHealth, setBeeHealth] = useState<BeeHealthData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchBeeHealth = async () => {
      try {
        const baseUrl = import.meta.env.VITE_BACKEND_URL || 'http://localhost:8080';
        const response = await fetch(`${baseUrl}/api/bees/status`);
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        const data = await response.json();
        setBeeHealth(data);
        setError(null);
      } catch (err) {
        console.error('Failed to fetch bee health:', err);
        setError(err instanceof Error ? err.message : 'Unknown error');
        setBeeHealth(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBeeHealth();
    const interval = setInterval(fetchBeeHealth, 30000);

    return () => clearInterval(interval);
  }, []);

  return { beeHealth, isLoading, error };
};
